export default __webpack_public_path__ + "geburtstag-chat-04.3861428d51b30130c8306f67a01682dc.png";